import * as React from "react";
import { Icon } from "./Icon.js";

export function SaveViewModal({
  onSave,
  onClose,
  filterSummary,
}: {
  onSave: (name: string) => Promise<void> | void;
  onClose: () => void;
  filterSummary: string;
}) {
  const [name, setName] = React.useState("");
  const [saving, setSaving] = React.useState(false);

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div
        className="modal card fade-in"
        style={{ maxWidth: 420 }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-h">
          <div>
            <div className="modal-title">Save filtered view</div>
            <div className="modal-sub">Anyone in your org will be able to open this view.</div>
          </div>
          <button className="icon-btn" onClick={onClose} aria-label="Close">
            <Icon name="x" size={14} />
          </button>
        </div>
        <div className="modal-body">
          <div className="exp-section">
            <div className="exp-label">View name</div>
            <input
              className="text"
              autoFocus
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g. Summer Camp — Unpaid"
            />
          </div>
          <div className="exp-preview">
            <div className="exp-fname"><Icon name="filter" size={13} /> {filterSummary}</div>
          </div>
        </div>
        <div className="modal-foot">
          <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
          <button
            className="btn btn-primary"
            disabled={!name.trim() || saving}
            onClick={async () => {
              setSaving(true);
              try { await onSave(name.trim()); } finally { setSaving(false); }
            }}
          >
            <Icon name="bookmark" size={14} /> Save view
          </button>
        </div>
      </div>
    </div>
  );
}
